module.exports = __webpack_public_path__ + "img/library-book.158753cf.svg";